import api from '..';

export const getTechnicalInsightRequest = (theme) =>
  api.get('/economic-insight/technical-insight', { params: { theme } });
